import { ContentType, request } from "../api";
import { baseParams } from "../common";

/**
 * Клиент согласился с новой ценой: бек применяет цену, которую сам показал при проверке (сумм не передаём).
 * Ответ: { applied, new_price, ... } либо { error_code: 35|58, price_check } если цена уехала ещё раз.
 */
export const updatePrice = async (data = {}, params = {}) => request({
  path: "/update-price",
  method: "POST",
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  secure: true,
  ...params,
});
